const stateName = '[Shared][AllocationAccessibility] ';

export class SharedAllocationAccessibilityLoadRelatedListAction {
    static readonly type = stateName + 'LoadRelatedList';
}
